type StaffIdentity = {
  name?: string | null;
};

type DoctorIdentity = {
  full_name?: string | null;
};

type UserIdentity = {
  email?: string | null;
};

export function getSidebarIdentityLabel(
  activeStaff: StaffIdentity | null | undefined,
  activeDoctor: DoctorIdentity | null | undefined,
  user: UserIdentity | null | undefined,
): string {
  for (const candidate of [
    activeStaff?.name,
    activeDoctor?.full_name,
    user?.email,
  ]) {
    if (typeof candidate === "string" && candidate.trim()) {
      return candidate.trim();
    }
  }

  return "";
}
